module.exports = __webpack_public_path__ + "img/import.0d056f0f.svg";